module.exports = __webpack_public_path__ + "img/how10.64827617.png";